export function saveState(key, state) {
	try {
		console.log('saveState')
		localStorage[key] = JSON.stringify({
			...state
		  , routing: undefined
		  ,	search: undefined
		  , data: {
		  		...state.data
		  	  , db: undefined
		  	  , idx: undefined
		  	  , updated: undefined
			}
		  , session: {
		  		...state.session
		  	  , authenticated: undefined
		  	  , password: undefined
			}
		  , attachments: undefined
		  , notifications: undefined
		  , 'yelp': undefined
		  , 'filters': undefined
		  , 'selectedRows': undefined
		  , 'prompt': undefined
		  , 'scrollTop': undefined
		  , 'commentBuffer': undefined
		  , 'error': undefined
		})
	} catch(e) { console.error(e) }
}

export function restoreState(key) {
	try {
		let localState = JSON.parse(localStorage[key])
		let state = {
			...localState
		  , data: {
				...localState.data
			  , buffer: (Object.keys(localState.data.buffer)[0] && window.location.pathname.search(Object.keys(localState.data.buffer)[0]) != -1) ?
					localState.data.buffer
					:
					{}
			}
		  , mode: (Object.keys(localState.data.buffer)[0] && window.location.pathname.search(Object.keys(localState.data.buffer)[0]) != -1) ? localState.mode : "view"
		}
		console.log(key + ' state restored', state)
		return state
	} catch (e) { console.error(e) }
}



// WEBPACK FOOTER //
// ./src/utils/redux/localStorage.js